/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import chevron from '../../../../../assets/images/chevron-icon.svg';

import { LargeIconLink, LargeIconTitle, LargeIconSubtitle, MegaMenuLargeIconLinkContainer } from '../MegaMenuStyles';
import { LazyLink } from '../../../../../../../../slices/atoms';

const navigationTracking = (name, category) => {
  window.analytics.track('Web Interaction', {
    action: 'click',
    category,
    name,
  });
};

const LargeIconLinks = data =>
  // Mapping through the Featured Product Mega Menu data or the Community Mega Menu data
  data.map(item => (
    <MegaMenuLargeIconLinkContainer
      renderAs={LazyLink}
      url={
        (item.solutions_link && item.solutions_link.url) ||
        (item.featured_product_link && item.featured_product_link.url) ||
        (item.community_link && item.community_link.url)
      }
      key={item.featured_product_title || item.community_title}
    >
      <LargeIconLink
        href={
          (item.solutions_link && item.solutions_link.url) ||
          (item.featured_product_link && item.featured_product_link.url) ||
          (item.community_link && item.community_link.url)
        }
        renderAs="a"
        className="content"
        onClick={() => {
          (item.solutions_tracking_name &&
            navigationTracking(item.solutions_tracking_name, item.solutions_tracking_category)) ||
            (item.community_tracking_name &&
              navigationTracking(item.community_tracking_name, item.community_tracking_category)) ||
            (item.featured_tracking_name &&
              navigationTracking(item.featured_tracking_name, item.featured_tracking_category));
        }}
      >
        <div>
          <LargeIconTitle>{item.solutions_title || item.featured_product_title || item.community_title}</LargeIconTitle>
          <LargeIconSubtitle>
            {item.solutions_subtitle || item.featured_product_subtitle || item.community_subtitle}
          </LargeIconSubtitle>
        </div>
        <img className="chevron" src={chevron} alt="chevron" />
      </LargeIconLink>
    </MegaMenuLargeIconLinkContainer>
  ));

export default LargeIconLinks;

LargeIconLinks.propTypes = {
  data: PropTypes.node.isRequired,
};
